import React, { useEffect, useRef, useState } from 'react';
import { MobileGameMusic } from '../../util/MobileGameMusic';
import { useGameWakeLock } from '../../hooks/useGameWakeLock';
import { ShinobiSpeaker } from '../../components/ShinobiSpeaker';

export function MobileAuthEffects() {
  useGameWakeLock(true);
  const music = useRef<MobileGameMusic>();
  const [sound, setSound] = useState(false);
  useEffect(() => {
    const player = new MobileGameMusic();
    player.setPlaylist({'-1':['maincity1.s111.mp3']});
    player.setVolume(18);
    player.play(-1);
    music.current = player;
    // Browsers require a touch before audio can start.
    const start = (event: Event) => {
      if ((event.target as Element)?.closest?.('.mobile-login-sound')) { document.removeEventListener('pointerdown', start); return; }
      player.setMuted(false); setSound(true);
      document.removeEventListener('pointerdown', start);
    };
    document.addEventListener('pointerdown', start);
    return () => { document.removeEventListener('pointerdown', start); player.dispose(); };
  }, []);
  return <>
    <div className="mobile-auth-leaves" aria-hidden="true">{Array.from({length:8},(_,i)=><i key={i} style={{left:`${i*14}%`,animationDelay:`-${i*1.7}s`,animationDuration:`${9+i%3*2}s`}} />)}</div>
    <button type="button" className="mobile-login-sound" aria-label={sound?'ปิดเพลงหน้าล็อกอิน':'เปิดเพลงหน้าล็อกอิน'} title={sound?'ปิดเพลง':'เปิดเพลง'} aria-pressed={sound} onClick={()=>{music.current?.setMuted(sound);setSound(!sound);}}>
      <ShinobiSpeaker muted={!sound}/>
    </button>
  </>;
}
